import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useSubmotive3Form } from './hook';
import { Submotive3Data } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    SUBMOTIVE3,
    SUBMOTIVE3_DETAIL,
    SUBMOTIVE3_EDIT,
    SUBMOTIVE3_NEW,
} from '../../../../../routes/paths';
import { Submotive3ParamsHistorical } from '../historical';

export const Submotive3Form = () => {
    const {
        submotive3,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubmotive3Data,
        submotive3Historical,
        showHistorical,
        setShowHistorical,
    } = useSubmotive3Form();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    submotive3 && submotive3.id
                        ? 'Editar submotivo 3'
                        : 'Crear submotivo 3'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={submotive3?.id || ''}
                        buttonCreate={{
                            show: Boolean(submotive3?.id),
                            route: SUBMOTIVE3_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE3,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: SUBMOTIVE3_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBMOTIVE3_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(submotive3?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <Submotive3ParamsHistorical
                        historical={submotive3Historical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <Submotive3Data
                data={submotive3}
                onChangeFormik={(formik) => setFormikSubmotive3Data(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
